import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck, Scale, LineChart, Users, ArrowRight } from 'lucide-react';
const boards = [{
  name: 'Utah Health Information Network',
  role: 'Board Member'
}, {
  name: 'Comagine Health',
  role: 'Board Member'
}, {
  name: 'Banterra Bank',
  role: 'Board Member'
}, {
  name: 'Advocacy Resource Center',
  role: 'Board Member'
}, {
  name: 'AMA Litigation Center',
  role: 'Board Chair'
}, {
  name: 'State Medical Association',
  role: 'Board Leadership'
}, {
  name: "Governor's Healthcare Reform Task Force",
  role: 'Appointed Member'
}];
const expertise = [{
  icon: ShieldCheck,
  title: 'Board Leadership',
  body: 'Chairing committees and guiding boards toward strategic clarity.'
}, {
  icon: Scale,
  title: 'Fiduciary Oversight',
  body: 'Ensuring sound financial stewardship and compliance.'
}, {
  icon: LineChart,
  title: 'Strategic Planning',
  body: 'Aligning organizational vision with measurable execution.'
}, {
  icon: Users,
  title: 'Executive Succession',
  body: 'Guiding leadership transitions and talent strategy.'
}];
export function BoardService() {
  useEffect(() => {
    document.title = 'Board Service & Governance | Michelle McOmber Board Director';
  }, []);
  return <div className="w-full bg-slate-50" data-id="element-153">
      <header className="bg-navy-900 text-white py-20" data-id="element-154">
        <div className="max-w-7xl mx-auto px-6" data-id="element-155">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-156">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-157">
              Board Service &amp; Governance
            </h1>
            <p className="text-xl text-slate-300 max-w-2xl" data-id="element-158">
              A trusted director with deep governance expertise across
              healthcare, banking, and policy organizations.
            </p>
          </motion.div>
        </div>
      </header>

      <section className="py-20" data-id="element-159">
        <div className="max-w-7xl mx-auto px-6" data-id="element-160">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-161">
            <div className="lg:col-span-2 space-y-12" data-id="element-162">
              <div data-id="element-163">
                <h2 className="text-3xl font-serif font-bold text-navy-900 mb-8" data-id="element-164">
                  Current &amp; Past Board Leadership
                </h2>
                <div className="space-y-6" data-id="element-165">
                  {boards.map((b, i) => <motion.div key={b.name} initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.4,
                  delay: i * 0.05
                }} className="flex items-center justify-between bg-white p-6 rounded-lg border border-slate-100" data-id="element-166">
                      <div data-id="element-167">
                        <p className="font-bold text-navy-900 text-lg" data-id="element-168">
                          {b.name}
                        </p>
                        <p className="text-slate-500 text-sm" data-id="element-169">
                          Governance &amp; oversight
                        </p>
                      </div>
                      <span className="inline-block bg-slate-100 text-navy-900 px-3 py-1 rounded-full text-sm font-medium" data-id="element-170">
                        {b.role}
                      </span>
                    </motion.div>)}
                </div>
              </div>
            </div>

            <div className="lg:col-span-1" data-id="element-171">
              <div className="bg-navy-900 text-white p-8 rounded-xl sticky top-32" data-id="element-172">
                <h2 className="text-2xl font-serif font-bold mb-6 text-white" data-id="element-173">
                  Governance Expertise
                </h2>
                <div className="space-y-6" data-id="element-174">
                  {expertise.map(e => <div key={e.title} className="flex items-start" data-id="element-175">
                      <e.icon className="w-6 h-6 text-gold mr-4 shrink-0" data-id="element-176" />
                      <div data-id="element-177">
                        <p className="font-bold mb-1" data-id="element-178">{e.title}</p>
                        <p className="text-slate-400 text-sm leading-relaxed" data-id="element-179">
                          {e.body}
                        </p>
                      </div>
                    </div>)}
                </div>
                <div className="mt-10 pt-8 border-t border-white/20" data-id="element-180">
                  <p className="font-bold mb-4" data-id="element-181">Board Candidate</p>
                  <p className="text-sm text-slate-300 mb-6" data-id="element-182">
                    Organizations seeking an experienced healthcare board member
                    are invited to connect.
                  </p>
                  <Link to="/contact" className="w-full bg-gold hover:bg-gold-600 text-white py-3 rounded text-center font-medium transition-colors flex items-center justify-center" data-id="element-183">
                    Inquire About Board Service
                    <ArrowRight className="w-4 h-4 ml-2" data-id="element-184" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}